import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeIndex from './Home/HomeIndex';
import Footer from './Component/Layout/Footer';
import ProductList from './Product/ProducList';
import Navigation from './Component/Layout/Navigation';
import BottomPanele from './Component/Layout/BottomPanel';
import ProducListSecand from './Product/ProducListSecand-old';
import ProductGraid from './Product/ProductGraid';
import MobileVirsionGrid from './Product/Mobileview/MobileVirsionGrid';
import ProductDetails from './ProductDetail.js/ProductDetails';
import Wishlist from './Component/Pages/Wishlist';
import CheckOut from './Component/Checkout/CheckOut';
import Summarys from './Component/Checkout/Summarys';
import ScrollToTop from './Component/ScrollToTop';
import PrivacyPolicy from './Component/PolicyPages/PrivacyPolicy';
import AboutUs from './Component/Pages/AboutUS';
import LoyaltyTerms from './Component/PolicyPages/LoyaltyTerms';
import LoginAdmin from './auth/LoginAdmin';
import TableWear from './Product/TableWear';
import Dustbin from './Product/Dustbin';
import Homedecor from './Product/Homedecor';
import Bathlines from './Product/Bathlines';
import Successfully from './Component/Checkout/Successfully';

function App() {
  return (
    <> 
    <Router>
      <Navigation/>
      <Routes>
          <Route path="/" element={<HomeIndex />} />
          <Route path="/productList" element={<ProductList />} />
          <Route path="/productListsecand" element={<ProducListSecand/>} />
          <Route path="/productgraid" element={<ProductGraid/>} />
          <Route path="/mobileGrid" element={<MobileVirsionGrid/>} />
          <Route path="/ProductDetails" element={<ProductDetails/>} />
          <Route path="/wishlist" element={<Wishlist/>} />
          <Route path="/checkout/cart" element={<CheckOut/>} />
          <Route path="/checkout/summary" element={<Summarys/>} />
          <Route path="/about" element={<AboutUs/>} />
          <Route path="/privacy" element={ <PrivacyPolicy/> } />
          <Route path="/loyalty" element={ <LoyaltyTerms/> } />
          <Route path='/Login' element={<LoginAdmin/>}/>
          <Route path='/tablewear' element={<TableWear/>}/>
          <Route path='/dustbin' element={<Dustbin/>}/>
          <Route path='/homedecor' element={<Homedecor/>}/>
          <Route path='/bathline' element={<Bathlines/>}/>
          <Route path="/ordersucessfull" element={<Successfully/>} />
      </Routes>
        <Footer />
        <BottomPanele/>
        <ScrollToTop/>
    </Router>
    </>
  );
}
export default App;
